import React, { useEffect } from 'react';
import { useRecoilState } from 'recoil';
import { preloaderState } from 'src/store/global/preloaderState';
import PreloaderCustom from './PreloaderCustom';

const Preloader = () => {
    const [preloader, setPreloader] = useRecoilState(preloaderState);
    useEffect(() => {
        if(preloader) {
            document.body.style.margin = 0
    
            setTimeout(() => {
                setPreloader(false)
            }, 2000)
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [preloader])

    if (!preloader) return null;

    return (
       <PreloaderCustom />
    )
};

export default Preloader;
